import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { COLOR_BLACK } from "shared/theme/colors";

export const StyledDataGrid = styled(DataGridPro)`
  border: none;
  cursor: pointer;

  & .MuiDataGrid-columnHeaderTitle {
    color: ${COLOR_BLACK};
    font-weight: 700;
  }

  & .MuiDataGrid-columnSeparator {
    display: none;
  }

  & .MuiDataGrid-iconButtonContainer {
    margin-left: 0.25rem;
  }

  & .MuiDataGrid-columnHeader,
  .MuiDataGrid-cell {
    padding: 0.5rem;
    white-space: normal;
    outline: none;

    &:focus,
    &:focus-within {
      outline: none;
    }
  }
`;

export const StyledPaper = styled(Paper)`
  box-shadow: none;
`;

export const StyledHeader = styled(Box)`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.5rem 1.5rem 0.5rem;
`;
